export interface SendNotificationPayload {
  title: string;
  body: string;
  target: 'all' | 'user';
  userId?: string;
}

export interface SendNotificationResult {
  success: boolean;
  totalTokens?: number;
  sent?: number;
  failed?: number;
  message?: string;
  error?: string;
}

export const sendCustomNotification = async (
  payload: SendNotificationPayload,
  token: string
): Promise<SendNotificationResult> => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/notifications/send`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data?.error || `Erreur ${res.status}: ${res.statusText}`);
  }
  return data;
};

export interface NotificationLogEntry {
  id_log: string;
  type: 'email' | 'push' | 'sms';
  recipient: string;
  subject: string;
  status: 'sent' | 'failed' | 'pending';
  error?: string;
  created_at: string;
}

export const getNotificationHistory = async (token: string): Promise<NotificationLogEntry[]> => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/notifications/admin-logs`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data?.error || `Erreur ${res.status}: ${res.statusText}`);
  }
  return data.data || [];
};
